export const ru = {
    'toggle-button-text-show': 'Показать полностью',
    'toggle-button-text-hide': 'Скрыть',
}
